import { useCallback } from 'react';
import fireGAEvent from './fireGAEvent';
function useGoogleAnalyticsEvent() {
    const fireEvent = useCallback((category, action, label, value) => {
        fireGAEvent(category, action, label, value);
    }, []);
    return fireEvent;
}
export default useGoogleAnalyticsEvent;
//# sourceMappingURL=useGoogleAnalyticsEvent.js.map